import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Upload, Button ,Modal, Image} from 'antd';
import Axios from 'axios';
import './FileUpload.css'

const FileUpload = ({ getFiles, files }) => {
    const [fileList, setFileList] = useState([]);

    async function fileFromBase64(base64, fileName) {
        try {
            // Split the base64 string to get the metadata part (before the comma)
            const base64Parts = base64.split(',');

            // Extract the MIME type from the first part of the base64 string (e.g., "data:image/png;base64")
            const mimeMatch = base64Parts[0].match(/:(.*?);/);
            const fileType = mimeMatch ? mimeMatch[1] : ''; // Extract the MIME type

            // Decode the base64 string to a binary string
            const binaryString = window.atob(base64Parts[1]);

            // Create a Uint8Array to store the binary data
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            // Map the binary string data to the Uint8Array
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            // Create a Blob from the array buffer
            const blob = new Blob([bytes], { type: fileType });

            // Create a File object from the Blob
            const file = new File([blob], fileName, { type: fileType });

            return file;
        } catch (error) {
            console.error('Error converting base64 to file:', error);
            return null;
        }
    }

 const test=async(file)=>{
  return file
}


    useEffect(() => {
        const loadFilesFromUrls = async () => {
            const processFiles=files.filter(x=>x.FilePath)
            let validFiles=[]
            if (processFiles.length > 0) {
                const fileListPromises = processFiles.map((file) =>fileFromBase64(file.FilePath, file.DocTitle));
                const fetchedFiles = await Promise.all(fileListPromises);
                // Filter out any null files in case of errors during fetch
                validFiles = fetchedFiles.filter((file) => file !== null);
               
            }
            
            setFileList([...files.filter(x=>!x.FilePath),...validFiles]);
        };

        loadFilesFromUrls();
    }, [files]);

    const handlePreview = async (file) => {
        if (file.type.startsWith('image/')) {
            // Handle image preview
            Modal.info({
                title: 'Image Preview',
                content: <Image src={file.url || URL.createObjectURL(file)} alt={file.name} style={{ width: '100%' }} />,
                width: 600,
            });
        } else if (file.type === 'application/pdf') {
            // Handle PDF preview (you could use an iframe or a library like pdfjs to show inline PDFs)
            const pdfUrl = file.url || URL.createObjectURL(file);
            Modal.info({
                title: 'PDF Preview',
                content: (
                    <iframe
                        src={pdfUrl}
                        title="PDF Preview"
                        style={{ width: '100%', height: '500px' }}
                    />
                ),
                width: 800,
            });
        } else if (
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            file.type === 'application/vnd.ms-excel'
        ) {
            // Handle Excel preview (e.g., prompt for download or render a simple message)
            const excelUrl = file.url || URL.createObjectURL(file);
            Modal.info({
                title: 'Excel Preview',
                content: (
                    <div>
                        <p>Click the link below to download and view the Excel file:</p>
                        <a href={excelUrl} download={file.name}>
                            {file.name}
                        </a>
                    </div>
                ),
                width: 600,
            });
        } else {
            console.error('Unsupported file type for preview');
        }
    };

    const handleChange = ({ fileList: newFileList }) => {
        newFileList=newFileList.map(x=>{
            if(x.originFileObj){
                return x.originFileObj
            }
            return x
        })
        setFileList(newFileList);
        getFiles(newFileList);
    };

    const handleRemove = (file) => {
        setFileList((prevList) => prevList.filter((f) => f.uid !== file.uid));
        getFiles(fileList.filter((f) => f.uid !== file.uid));
    };

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Add Ref Docs</div>
        </button>
    );

    const beforeUpload = (file) => {
        const isValid = 
            file.type === 'application/pdf' ||
            file.type.startsWith('image/') ||
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || // for .xlsx
            file.type === 'application/vnd.ms-excel'; // for .xls
    
        if (!isValid) {
            console.error('You can only upload image, PDF, and Excel files!');
            return false;
        }
    
        setFileList((prevList) => [...prevList, file]);
        return false; // prevent the upload
    };
    
    return (
        <>
            <Upload
                className="ml-2"
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onRemove={handleRemove} // Custom remove handler
                onChange={handleChange}
                beforeUpload={beforeUpload}
                accept="image/*,.pdf,.xls,.xlsx"
            >
                {fileList.length >= 8 ? null : uploadButton}
            </Upload>
        </>
    );
    
};

export default FileUpload;
